
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-ii-main-2022-test-series-paper-i",
      function () {
        return require("private-next-pages/tnpsc-group-ii-main-2022-test-series-paper-i/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-ii-main-2022-test-series-paper-i"])
      });
    }
  